import Icon from "./IconBase.js";
const DownBlueArrowIcon = (props) => {
  return (
    <Icon width="16" height="16" viewBox="0 0 16 16" {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.6663 5.66699L7.99968 10.3337L3.33301 5.66699"
          stroke="#00B0F5"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
export default DownBlueArrowIcon;
